<ng-container *subscribe="imageSource$ as imageSource">
    <ng-container *ngTemplateOutlet="contentTemplate; context: { $implicit: imageSource }">
    </ng-container>
</ng-container>
